const LinkCreate = (slog, delimiter = "-") => {

    if (slog.length != 0) {
        slog = slog.trim();
        slog = slog.replace('‌', ' ');
        slog = slog.replace('  ', ' ');
        slog = slog.replace('  ', ' ');
        slog = slog.replace(/\s/g, delimiter);

        slog = slog.toLowerCase();
        // if (preFix !== null){
        //     slog = slog.replace(preFix, '');
        //     slog = slog.replace(/\s/g, '-');
        //     preFix = preFix.toLowerCase();
        //     return preFix + slog;
        // }
        return slog;
    }
    return slog;
}

export default LinkCreate;

